import React, { useEffect, useState } from 'react';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { StatusChip } from '../components/ui/StatusChip';
import { Link } from 'react-router-dom';
import { UploadIcon, SearchIcon, SortAscIcon, SortDescIcon, ChevronLeftIcon, ChevronRightIcon, FilterIcon, ClipboardListIcon } from 'lucide-react';
export function Scadenze() {
  const [importMode, setImportMode] = useState('manuale');
  const [scadenze, setScadenze] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortField, setSortField] = useState('dataScadenza');
  const [sortDirection, setSortDirection] = useState('asc');
  const [filterStatus, setFilterStatus] = useState('all');
  const itemsPerPage = 10;
  // Effetto per caricare le impostazioni di integrazione
  useEffect(() => {
    // Simulazione di caricamento delle impostazioni dal server
    setTimeout(() => {
      setImportMode('manuale'); // o 'automatico' a seconda della configurazione
      setLoading(false);
    }, 500);
  }, []);
  // Effetto per caricare i dati delle scadenze
  useEffect(() => {
    // Simulazione di caricamento dati dal server
    setTimeout(() => {
      const dummyData = [{
        id: 1,
        cliente: 'Rossi SRL',
        numeroFattura: 'FT-2023-001',
        importo: 1250.0,
        dataEmissione: '2023-05-15',
        dataScadenza: '2023-06-15',
        stato: 'overdue',
        giorni: 20,
        pianoRientro: {
          id: 'plan-1',
          nome: 'Piano rientro Q1 2023'
        }
      }, {
        id: 2,
        cliente: 'Bianchi SpA',
        numeroFattura: 'FT-2023-042',
        importo: 780.5,
        dataEmissione: '2023-05-20',
        dataScadenza: '2023-06-20',
        stato: 'overdue',
        giorni: 15,
        pianoRientro: null
      }, {
        id: 3,
        cliente: 'Verdi & Co.',
        numeroFattura: 'FT-2023-108',
        importo: 2340.75,
        dataEmissione: '2023-06-01',
        dataScadenza: '2023-07-01',
        stato: 'due-soon',
        giorni: 5,
        pianoRientro: {
          id: 'plan-3',
          nome: 'Piano rientro Annuale 2023'
        }
      }, {
        id: 4,
        cliente: 'Neri Industrie',
        numeroFattura: 'FT-2023-156',
        importo: 4500.0,
        dataEmissione: '2023-06-10',
        dataScadenza: '2023-07-10',
        stato: 'due-soon',
        giorni: 15,
        pianoRientro: null
      }, {
        id: 5,
        cliente: 'Gialli Costruzioni',
        numeroFattura: 'FT-2023-201',
        importo: 12500.0,
        dataEmissione: '2023-06-15',
        dataScadenza: '2023-07-15',
        stato: 'due-soon',
        giorni: 20,
        pianoRientro: null
      }, {
        id: 6,
        cliente: 'Rossi SRL',
        numeroFattura: 'FT-2023-002',
        importo: 450.0,
        dataEmissione: '2023-04-10',
        dataScadenza: '2023-05-10',
        stato: 'paid',
        giorni: 0,
        pianoRientro: {
          id: 'plan-1',
          nome: 'Piano rientro Q1 2023'
        }
      }, {
        id: 7,
        cliente: 'Marroni Logistica',
        numeroFattura: 'FT-2023-078',
        importo: 890.25,
        dataEmissione: '2023-04-22',
        dataScadenza: '2023-05-22',
        stato: 'paid',
        giorni: 0,
        pianoRientro: null
      }, {
        id: 8,
        cliente: 'Viola Servizi',
        numeroFattura: 'FT-2023-115',
        importo: 1100.0,
        dataEmissione: '2023-05-05',
        dataScadenza: '2023-06-05',
        stato: 'overdue',
        giorni: 30,
        pianoRientro: {
          id: 'plan-4',
          nome: 'Piano rientro Marzo-Agosto'
        }
      }, {
        id: 9,
        cliente: 'Azzurri Tech',
        numeroFattura: 'FT-2023-187',
        importo: 3200.5,
        dataEmissione: '2023-06-20',
        dataScadenza: '2023-07-20',
        stato: 'due-soon',
        giorni: 25,
        pianoRientro: null
      }, {
        id: 10,
        cliente: 'Rosa Commercio',
        numeroFattura: 'FT-2023-222',
        importo: 760.0,
        dataEmissione: '2023-06-25',
        dataScadenza: '2023-07-25',
        stato: 'due-soon',
        giorni: 30,
        pianoRientro: null
      }, {
        id: 11,
        cliente: 'Bianchi SpA',
        numeroFattura: 'FT-2023-043',
        importo: 1500.0,
        dataEmissione: '2023-06-02',
        dataScadenza: '2023-07-02',
        stato: 'due-soon',
        giorni: 7,
        pianoRientro: {
          id: 'plan-5',
          nome: 'Piano rientro Semestrale'
        }
      }, {
        id: 12,
        cliente: 'Verdi & Co.',
        numeroFattura: 'FT-2023-109',
        importo: 950.25,
        dataEmissione: '2023-05-12',
        dataScadenza: '2023-06-12',
        stato: 'overdue',
        giorni: 23,
        pianoRientro: {
          id: 'plan-3',
          nome: 'Piano rientro Annuale 2023'
        }
      }];
      setScadenze(dummyData);
    }, 1000);
  }, []);
  // Funzione per caricare un file
  const handleFileUpload = event => {
    const file = event.target.files[0];
    if (!file) return;
    // Qui andrebbe la logica per caricare il file
    alert(`File selezionato: ${file.name}`);
    // Reset dell'input file
    event.target.value = null;
  };
  // Funzione per gestire il cambio di ordinamento
  const handleSort = field => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };
  // Funzioni per filtrare e ordinare i dati
  const filteredData = scadenze.filter(item => {
    // Filtra per termine di ricerca
    const matchesSearch = item.cliente.toLowerCase().includes(searchTerm.toLowerCase()) || item.numeroFattura.toLowerCase().includes(searchTerm.toLowerCase()) || item.pianoRientro && item.pianoRientro.nome.toLowerCase().includes(searchTerm.toLowerCase());
    // Filtra per stato
    const matchesStatus = filterStatus === 'all' || filterStatus === 'paid' && item.stato === 'paid' || filterStatus === 'due-soon' && item.stato === 'due-soon' || filterStatus === 'overdue' && item.stato === 'overdue';
    return matchesSearch && matchesStatus;
  });
  // Ordina i dati
  const sortedData = [...filteredData].sort((a, b) => {
    if (sortField === 'importo' || sortField === 'giorni') {
      return sortDirection === 'asc' ? a[sortField] - b[sortField] : b[sortField] - a[sortField];
    } else if (sortField === 'pianoRientro') {
      // Gestisce l'ordinamento per piano di rientro
      if (!a.pianoRientro && !b.pianoRientro) return 0;
      if (!a.pianoRientro) return sortDirection === 'asc' ? 1 : -1;
      if (!b.pianoRientro) return sortDirection === 'asc' ? -1 : 1;
      return sortDirection === 'asc' ? a.pianoRientro.nome.localeCompare(b.pianoRientro.nome) : b.pianoRientro.nome.localeCompare(a.pianoRientro.nome);
    } else {
      return sortDirection === 'asc' ? a[sortField].localeCompare(b[sortField]) : b[sortField].localeCompare(a[sortField]);
    }
  });
  // Paginazione
  const totalPages = Math.ceil(sortedData.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);
  // Formattazione dell'importo
  const formatCurrency = amount => {
    return new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'EUR'
    }).format(amount);
  };
  // Formattazione della data
  const formatDate = dateString => {
    const date = new Date(dateString);
    return date.toLocaleDateString('it-IT');
  };
  // Renderizza l'icona di ordinamento
  const renderSortIcon = field => {
    if (sortField !== field) return null;
    return sortDirection === 'asc' ? <SortAscIcon className="h-4 w-4 ml-1" data-id="element-2431" /> : <SortDescIcon className="h-4 w-4 ml-1" data-id="element-2432" />;
  };
  return <div className="space-y-6 pb-16" data-id="element-2433">
      <div data-id="element-2434">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-2435">Scadenze</h1>
        <p className="mt-1 text-sm text-gray-500" data-id="element-2436">
          Gestisci le scadenze importate dal tuo gestionale
        </p>
      </div>
      <div className="bg-white shadow rounded-lg overflow-hidden" data-id="element-2437">
        {/* Toolbar */}
        <div className="px-4 py-5 sm:p-6 border-b border-gray-200" data-id="element-2438">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-3 md:space-y-0" data-id="element-2439">
            <div className="w-full md:w-1/3" data-id="element-2440">
              <div className="relative rounded-md shadow-sm" data-id="element-2441">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-2442">
                  <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-2443" />
                </div>
                <input type="text" className="focus:ring-[#1A3E5C] focus:border-[#1A3E5C] block w-full pl-10 sm:text-sm border-gray-300 rounded-md" placeholder="Cerca per cliente, numero fattura o piano..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-2444" />
              </div>
            </div>
            <div className="flex space-x-3" data-id="element-2445">
              <div data-id="element-2446">
                <select className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-[#1A3E5C] focus:border-[#1A3E5C] sm:text-sm rounded-md" value={filterStatus} onChange={e => setFilterStatus(e.target.value)} data-id="element-2447">
                  <option value="all" data-id="element-2448">Tutti gli stati</option>
                  <option value="paid" data-id="element-2449">Pagato</option>
                  <option value="due-soon" data-id="element-2450">In Scadenza</option>
                  <option value="overdue" data-id="element-2451">Scaduto</option>
                </select>
              </div>
              <Button type="button" variant="secondary" icon={<div className="h-4 w-4 mr-2" data-id="element-2453" />} onClick={() => {
              setSearchTerm('');
              setFilterStatus('all');
              setSortField('dataScadenza');
              setSortDirection('asc');
            }} data-id="element-2452">
                Reset
              </Button>
              <div data-id="element-2454">
                <input type="file" id="file-upload" className="sr-only" accept=".csv,.xlsx,.xls" onChange={handleFileUpload} disabled={importMode === 'automatico'} data-id="element-2455" />
                <label htmlFor="file-upload" className={`inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-[#1A3E5C] hover:bg-[#15324a] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#1A3E5C] ${importMode === 'automatico' ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`} data-id="element-2456">
                  <UploadIcon className="h-4 w-4 mr-2" data-id="element-2457" />
                  Importa Scadenze
                </label>
              </div>
            </div>
          </div>
        </div>
        {/* Tabella */}
        <div className="overflow-x-auto" data-id="element-2458">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-2459">
            <thead className="bg-gray-50" data-id="element-2460">
              <tr data-id="element-2461">
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer" onClick={() => handleSort('cliente')} data-id="element-2462">
                  <div className="flex items-center" data-id="element-2463">
                    Cliente
                    {renderSortIcon('cliente')}
                  </div>
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer" onClick={() => handleSort('numeroFattura')} data-id="element-2464">
                  <div className="flex items-center" data-id="element-2465">
                    Fattura
                    {renderSortIcon('numeroFattura')}
                  </div>
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer" onClick={() => handleSort('importo')} data-id="element-2466">
                  <div className="flex items-center" data-id="element-2467">
                    Importo
                    {renderSortIcon('importo')}
                  </div>
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer" onClick={() => handleSort('dataEmissione')} data-id="element-2468">
                  <div className="flex items-center" data-id="element-2469">
                    Data Emissione
                    {renderSortIcon('dataEmissione')}
                  </div>
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer" onClick={() => handleSort('dataScadenza')} data-id="element-2470">
                  <div className="flex items-center" data-id="element-2471">
                    Data Scadenza
                    {renderSortIcon('dataScadenza')}
                  </div>
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2472">
                  Stato
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer" onClick={() => handleSort('pianoRientro')} data-id="element-2473">
                  <div className="flex items-center" data-id="element-2474">
                    Piano di Rientro
                    {renderSortIcon('pianoRientro')}
                  </div>
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer" onClick={() => handleSort('giorni')} data-id="element-2475">
                  <div className="flex items-center" data-id="element-2476">
                    Giorni
                    {renderSortIcon('giorni')}
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-2477">
              {loading ? <tr data-id="element-2478">
                  <td colSpan={8} className="px-6 py-4 text-center text-sm text-gray-500" data-id="element-2479">
                    Caricamento in corso...
                  </td>
                </tr> : currentItems.length === 0 ? <tr data-id="element-2480">
                  <td colSpan={8} className="px-6 py-4 text-center text-sm text-gray-500" data-id="element-2481">
                    Nessuna scadenza trovata
                  </td>
                </tr> : currentItems.map(scadenza => <tr key={scadenza.id} className="hover:bg-gray-50" data-id="element-2482">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-2483">
                      {scadenza.cliente}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2484">
                      {scadenza.numeroFattura}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2485">
                      {formatCurrency(scadenza.importo)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2486">
                      {formatDate(scadenza.dataEmissione)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2487">
                      {formatDate(scadenza.dataScadenza)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-2488">
                      <StatusChip status={scadenza.stato} data-id="element-2489" />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm" data-id="element-2490">
                      {scadenza.pianoRientro ? <Link to={`/piani-rientro?piano=${scadenza.pianoRientro.id}`} className="inline-flex items-center text-[#1A3E5C] hover:text-[#15324a]" data-id="element-2491">
                          <ClipboardListIcon className="h-4 w-4 mr-1" data-id="element-2492" />
                          {scadenza.pianoRientro.nome}
                        </Link> : <span className="text-gray-400" data-id="element-2493">-</span>}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2494">
                      {scadenza.stato === 'paid' ? '-' : `${scadenza.giorni} giorni`}
                    </td>
                  </tr>)}
            </tbody>
          </table>
        </div>
        {/* Paginazione */}
        {!loading && sortedData.length > 0 && <div className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6" data-id="element-2495">
            <div className="flex-1 flex justify-between sm:hidden" data-id="element-2496">
              <Button variant="secondary" onClick={() => setCurrentPage(Math.max(1, currentPage - 1))} disabled={currentPage === 1} data-id="element-2497">
                Precedente
              </Button>
              <Button variant="secondary" onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))} disabled={currentPage === totalPages} data-id="element-2498">
                Successivo
              </Button>
            </div>
            <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between" data-id="element-2499">
              <div data-id="element-2500">
                <p className="text-sm text-gray-700" data-id="element-2501">
                  Visualizzazione{' '}
                  <span className="font-medium" data-id="element-2502">{indexOfFirstItem + 1}</span> a{' '}
                  <span className="font-medium" data-id="element-2503">
                    {Math.min(indexOfLastItem, sortedData.length)}
                  </span>{' '}
                  di <span className="font-medium" data-id="element-2504">{sortedData.length}</span>{' '}
                  risultati
                </p>
              </div>
              <div data-id="element-2505">
                <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination" data-id="element-2506">
                  <button onClick={() => setCurrentPage(Math.max(1, currentPage - 1))} disabled={currentPage === 1} className={`relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium ${currentPage === 1 ? 'text-gray-300 cursor-not-allowed' : 'text-gray-500 hover:bg-gray-50'}`} data-id="element-2507">
                    <span className="sr-only" data-id="element-2508">Precedente</span>
                    <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-2509" />
                  </button>
                  {/* Pulsanti pagina */}
                  {Array.from({
                length: Math.min(totalPages, 5)
              }, (_, i) => {
                let pageNum;
                if (totalPages <= 5) {
                  pageNum = i + 1;
                } else if (currentPage <= 3) {
                  pageNum = i + 1;
                } else if (currentPage >= totalPages - 2) {
                  pageNum = totalPages - 4 + i;
                } else {
                  pageNum = currentPage - 2 + i;
                }
                return <button key={pageNum} onClick={() => setCurrentPage(pageNum)} className={`relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium ${currentPage === pageNum ? 'z-10 bg-[#1A3E5C]/10 border-[#1A3E5C] text-[#1A3E5C]' : 'text-gray-500 hover:bg-gray-50'}`} data-id="element-2510">
                          {pageNum}
                        </button>;
              })}
                  <button onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))} disabled={currentPage === totalPages} className={`relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium ${currentPage === totalPages ? 'text-gray-300 cursor-not-allowed' : 'text-gray-500 hover:bg-gray-50'}`} data-id="element-2511">
                    <span className="sr-only" data-id="element-2512">Successivo</span>
                    <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-2513" />
                  </button>
                </nav>
              </div>
            </div>
          </div>}
      </div>
    </div>;
}